import { Badge, Col, Row } from 'react-bootstrap';

import { DOICited } from './citations/DOICited';
import { CONFIG } from './config';
import { DOIDataAccess } from './DOIDataAccess';
import { DOIRelated } from './DOIRelated';
import { DOITypes } from './DOITypes';
import { DOIMetatada } from './metadata/DOIMetatada';
import { DOIParticipants } from './participants/DOIParticipants';
import { DOIReference } from './reference/DOIReference';
import { DOIExperimentReport } from './report/DOIExperimentReport';
import { type DOI } from './utils/doi';

export function DOIInfo({ doi }: { doi: DOI }) {
  return (
    <>
      <Row className="mb-2">
        <DOITypes doi={doi} />
      </Row>
      <Row className="g-2">
        <Col xs={12} lg={7} xl={8} xxl={9}>
          <Row className="g-2">
            <Col xs={12}>
              <h3 style={{ marginTop: '-0.25rem' }}>{doi.title}</h3>
            </Col>
            <Col xs={12}>
              <DOIParticipants doi={doi} />
            </Col>
            <Col xs={12}>
              <pre
                className="m-0"
                style={{
                  textAlign: 'justify',
                  whiteSpace: 'pre-wrap',
                  wordWrap: 'break-word',
                  fontFamily: 'inherit',
                  overflowWrap: 'break-word',
                  overflowX: 'hidden',
                }}
              >
                {doi.description}
              </pre>
            </Col>
            {!!doi.keywords?.length && (
              <Col xs={12}>
                <div className="d-flex flex-wrap gap-1 mb-2">
                  {doi.keywords.map((keyword) => (
                    <Badge key={keyword} bg="secondary">
                      {keyword}
                    </Badge>
                  ))}
                </div>
              </Col>
            )}
            <Col xs={12} sm={CONFIG.EXPERIMENT_REPORT.enabled ? 6 : 12}>
              <DOIDataAccess doi={doi} />
            </Col>
            {CONFIG.EXPERIMENT_REPORT.enabled ? (
              <Col xs={12} sm={6}>
                <DOIExperimentReport doi={doi} />
              </Col>
            ) : null}
            <Col xs={12}>
              <DOIReference doi={doi}>
                Researchers must acknowledge the source of the data and cite its
                unique identifier as well as any publications linked to the same
                raw data. Below is the recommended format for citing this work
                in a research publication:
              </DOIReference>
            </Col>
            <Col xs={12}>
              <DOICited doi={doi} />
            </Col>
          </Row>
        </Col>
        <Col xs={12} lg={5} xl={4} xxl={3}>
          <Row className="g-2">
            <Col xs={12}>
              <DOIMetatada doi={doi} />
            </Col>
            <Col xs={12}>
              <DOIRelated doi={doi} />
            </Col>
          </Row>
        </Col>
      </Row>
    </>
  );
}
